module.exports = __webpack_public_path__ + "img/mobile-14.8c09867b.png";